import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {DateAdapter} from '@angular/material/core';
import {MatTableDataSource} from '@angular/material/table';
import {ErrorStateMatcher} from '@angular/material/core';
import {Ordered} from '../models/ordered';
import {OrderedDialogComponent} from './dialogs/ordered-dialog/ordered-dialog.component';
import {OrderedService} from '../services/ordered.service';
import {MatPaginator} from '@angular/material/paginator';
import {Subscription} from 'rxjs';
import {FormGroup, FormGroupDirective, FormControl, NgForm} from '@angular/forms';
import {ProductService} from '../services/product.service';
import {Member} from '../models/member';
import {MemberService} from '../services/member.service';

import {TaxService} from '../services/tax.service';
import {Tax} from '../models/tax';
import {OrderedFileDialogComponent} from './dialogs/ordered-file-dialog/ordered-file-dialog.component';
import {Product} from '../models/product';
import {OrderedFailDialogComponent} from './dialogs/ordered-fail-dialog/ordered-fail-dialog.component';
import {OrderedViewerDialogComponent} from './dialogs/ordered-viewer-dialog/ordered-viewer-dialog.component';
import {SubcategoryService} from '../services/subcategory.service';
import {SpinnerService} from '../shared/waiting/spinner.service';
import {FileService} from '../services/file.service';


export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-ordered',
  templateUrl: './ordered.component.html',
  styleUrls: [ './ordered.component.scss' ],
  entryComponents: [
    OrderedDialogComponent
  ]
})
export class OrderedComponent implements OnInit {

  /*name of the excel-file which will be downloaded. */
  fileName = 'ExcelSheet.xlsx';

  private subMembers: Subscription;
  private subOrders: Subscription;

  //public displayedColumns: string[] = [ 'icon', 'date', 'member_name', 'origin', 'payment_type', 'tax', 'member_debit', 'value', 'total', 'total_minus_tax', 'edit' ];
  //public displayedColumns: string[] = [ 'icon', 'date', 'member_name', 'origin', 'payment_type', 'total', 'edit' ];
  public displayedColumns: string[] = [ 'date', 'name', 'payment', 'debit', 'discount', 'tax', 'value', 'total', 'total_minus_tax', 'edit' ];


  public matcher = new FormErrorStateMatcher();
  public intervalForm: FormGroup;

  public arrayMembers: Member[] = []
  public arrayTaxs: Tax[] = []


  public arrayProducts: Product[] = []
  public arrayProductsHistoric: Product[] = []

  public selectedProduct: any = {};
  public local_title: string = 'Inscrições'

  public ngFlag: boolean = false;
  public failFlag: boolean = false;

  public arrayOrders: Ordered[] = [];
  public arrayOrdersFail: Ordered[] = [];
  public orderedDataSource: MatTableDataSource<any>;

  public totalOrdered: number = 0;
  public totalOrdered_minus_tax: number = 0;
  public countOrdered: number = 0;

  constructor (
    private _memberService: MemberService,
    public _orderedService: OrderedService,
    public _productService: ProductService,
    public _subCategoryService: SubcategoryService,
    public _taxService: TaxService,
    private dialog: MatDialog,
    private _spinnerService: SpinnerService,
    private _fileService: FileService,
    private _adapter: DateAdapter<any>) {

    this.loadMembers()
    this.loadTaxs()
    this.loadProducts()
    this._orderedService.loadSubcategories()
  }

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  ngOnInit () {
    this._adapter.setLocale('pt');
    this.intervalForm = this._orderedService.createIntervalForm()

    this._orderedService.loadCieloCodes();

    // this.loadAllOrders()

  }


  ngOnDestroy () {
    if (this.subMembers)
      this.subMembers.unsubscribe();
    if (this.subOrders)
      this.subOrders.unsubscribe();
  }

  applyFilter (filterValue: string) {
    this.orderedDataSource.filter = filterValue.trim().toLowerCase();

    //if (this.orderedDataSource.paginator) {
    // this.orderedDataSource.paginator.firstPage();
    //}
  }

  openDialog (entity) {

    let data: Ordered = new Ordered();

    if (entity) {
      data = entity;
    }

    this.dialog.open(OrderedDialogComponent, {
      width: '800px',
      height: '640px',
      panelClass: 'custom-dialog-container',
      data: {'product': this.selectedProduct, 'ordered': data}
    });
  }

  openViewerDialog (entity) {

    this.dialog.open(OrderedViewerDialogComponent, {
      width: '750px',
      height: '565px',
      panelClass: 'custom-dialog-container',
      data: {'ordered': entity, 'new_order': false}
    });

  }

  openFailDialog () {

    this.dialog.open(OrderedFailDialogComponent, {
      width: '1024px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: this.arrayOrdersFail
    });

  }

  selectOrdersByProduct (event) {

    const waiting = this._spinnerService.show();

    let prod: any = {}

    prod = this.arrayProducts.find((e) => {
      return e.id == event
    })
    if (!prod) {
      prod = this.arrayProductsHistoric.find((e) => {
        return e.id == event
      })
    }
    this.selectedProduct = prod

    //  console.log("selectOrdersByProduct: " + JSON.stringify(prod))

    this.subOrders = this._orderedService.loadOrdered(prod.id)
      .subscribe((result) => {

        this.arrayOrders = []
        this.totalOrdered = 0;
        this.totalOrdered_minus_tax = 0;
        this.countOrdered = 0;

        // let array: any = []
        // let count: number = 0

        //const array: any = []

        result.forEach((item) => {

          if (item.payload.doc.data().returnCode == "00" && item.payload.doc.data().member_name) {

            const order = this._orderedService.createOrderObj(item)

            /*
              if (order.payment_type === 'CreditCard') {
    
              const taxBrand = this._orderedService.cielo_values.find((e) => {
                return e.brand === order.card_brand
              })
    
              const brand = taxBrand.values.find((e) => {
                return e.installments === order.card_installments
              })
              order.tax = brand.tax
              }
            */

            this.arrayOrders.push(order)

            if (order.payment_type == 'Billet' && order.origin == 'GN1') {
              this.totalOrdered_minus_tax += order.total - 3.5// item.payload.doc.data().total_minus_tax ? Number(item.payload.doc.data().total_minus_tax) : 0
            } else {
              this.totalOrdered_minus_tax += order.total_minus_tax ? Number(order.total_minus_tax) : 0
            }

            this.totalOrdered += order.total ? Number(order.total) : 0
            this.countOrdered += 1

          } else {
            this.arrayOrdersFail.push(this._orderedService.createOrderObj(item))
          }
        })

        //  console.log(count)
        //  console.log(JSON.stringify(array))
        //
        //  console.log("arrayOrders: " + JSON.stringify(this.arrayOrders))

        this.orderedDataSource = new MatTableDataSource(this.arrayOrders)
        this.orderedDataSource.sort = this.sort;
        //  this.orderedDataSource.paginator = this.paginator;

        waiting.close();

      })

    this.local_title = "Inscrições: " + this.selectedProduct.name
    this.ngFlag = true;

  }

  refreshOrdersByProduct () {
    this.selectOrdersByProduct(this.selectedProduct.id)
  }

  exportToCsv () {

    const data = this.arrayOrders

    let csvFile: any[] = []

    csvFile.push("" + ";" + this.selectedProduct.name + '\r\n')

    let csvHeader: string;
    csvHeader = "" + ";"
    csvHeader += 'Data' + ';'
    csvHeader += 'Nome' + ';'
    csvHeader += 'Categoria' + ';'
    csvHeader += 'Módulo' + ';'
    csvHeader += 'CPF' + ';'
    csvHeader += 'Cidade' + ';'
    csvHeader += 'UF' + ';'
    csvHeader += 'Celular' + ';'
    csvHeader += 'E-mail' + ';'
    csvHeader += 'Origem' + ';'
    csvHeader += 'Transação' + ';'
    csvHeader += 'Parcelas' + ';'

    csvHeader += 'Valor' + ';'
    csvHeader += 'Débito' + ';'
    csvHeader += 'Descontos' + ';'
    csvHeader += 'Total' + ';'
    csvHeader += 'Taxa' + ';'
    csvHeader += 'Liquido' + '\r\n'

    csvFile.push(csvHeader)

    //  let countLine:number = 1;
    data.forEach((line) => {

      let dt: any = line.date

      let dt_pedido = new Date(dt.seconds * 1000)
      let dt_pedido_formated = this.formatDate(dt_pedido)

      let member: any = this.arrayMembers.find((e) => {
        return line.member_id == e.id
      })

      if (!member) {
        console.log("not member: " + line.member_id)
      }

      //   console.log("member: " + JSON.stringify(member))

      let total;
      if (line.total) {
        total = line.total.toString().replace(".", ",")
      } else {
        total = ""
      }


      let total_minus_tax;
      if (line.total_minus_tax) {
        total_minus_tax = line.total_minus_tax.toString().replace(".", ",")
      } else {
        total_minus_tax = ""
      }

      let discount
      if (line.discount) {
        discount = line.discount.toString().replace(".", ",")
      } else {
        discount = ""
      }

      let tid = line.Tid ? line.Tid : 0;

      let tax: any = line.tax

      let member_debit;
      if (line.member_debit) {
        member_debit = line.member_debit.toString().replace(".", ",")
      } else {
        member_debit = ""
      }

      let value;
      if (line.value) {
        value = line.value.toString().replace(".", ",")
      } else {
        value = ""
      }

      let member_city;
      let member_state;

      if (member) {
        member_city = member.city ? member.city : "-"
        member_state = member.state ? member.state : "-"
      }

      let installments: number = 1
      if (!line.card_installments) {
        installments = 1
      } else {
        installments = line.card_installments
      }

      let csvLine: string;

      //  csvLine += "" + ";"
      //  csvLine += this.selectedProduct.name + ";"
      csvLine = "" + ";"
      csvLine += dt_pedido_formated + ";"
      csvLine += line.member_name + ";"
      csvLine += line.category_name + ";"
      csvLine += line.topic_name ? line.topic_name.substring(0,34) + ";": '' + ";"

      if (member)
        csvLine += member.cpf + ";"
      else
        csvLine += '-' + ";"

      csvLine += member_city + ";"
      csvLine += member_state + ";"

      if (member)
        csvLine += member.cellPhone + ";"
      else
        csvLine += '-' + ";"

      if (member)
        csvLine += member.email + ";"
      else
        csvLine += '-' + ";"

      csvLine += line.origin + ";"
      csvLine += tid + ";"
      csvLine += installments + ";"
      csvLine += value + ";"
      csvLine += member_debit + ";"
      csvLine += discount + ";"
      csvLine += total + ";"

      csvLine += tax + ";"
      csvLine += total_minus_tax + "\r\n"

      csvFile.push(csvLine)

    })




    //   console.log("csvFile: " + JSON.stringify(csvFile))

    var BOM = "\ufeff";
    let csvData = BOM + csvFile;

    var blob = new Blob([ csvData ], {type: "text/csv;charset=utf-8"});
    this._fileService.saveFile(blob, "inscritos.csv");
  }

  importFromCsv () {

    this.dialog.open(OrderedFileDialogComponent, {
      width: '800px',
      height: '540px',
      panelClass: 'custom-dialog-container',
      data: this.selectedProduct
    });
  }

  formatDate (date: Date) {

    if (date) {
      let dt = date.toISOString()
      let dd: any = dt.substr(8, 2);
      let mm: any = dt.substr(5, 2);
      let yy: any = dt.substr(0, 4);
      return dd + "/" + mm + "/" + yy
    } else {
      return ""
    }
  }

  loadMembers () {

    this.subMembers = this._memberService.select()
      .subscribe((result) => {
        this.arrayMembers = result.map(item => {
          let entity = new Member();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.category = item.payload.doc.data().category;
          entity.city = item.payload.doc.data().city;
          entity.state = item.payload.doc.data().state;
          entity.email = item.payload.doc.data().email;
          entity.cpf = item.payload.doc.data().cpf;
          entity.cellPhone = item.payload.doc.data().cellPhone;
          return entity;
        });


      },
        (error) => {
          console.log(JSON.stringify(error))
        })

  }

  loadTaxs () {

    this.subMembers = this._taxService.select()
      .subscribe((result) => {

        this.arrayTaxs = result.map(item => {
          let entity = new Tax();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.value = Number(item.payload.doc.data().value);
          return entity;
        });


      },
        (error) => {
          console.log(JSON.stringify(error))
        })

  }

  loadProducts () {
    this._productService.selectAllProducts()
      .subscribe((result) => {

        result.forEach((item) => {

          //if (item.payload.doc.data().active) {

          let product = new Product();
          product.id = item.payload.doc.id;
          product.name = item.payload.doc.data().name;
          product.text = item.payload.doc.data().text;
          product.image = item.payload.doc.data().image;
          product.active = item.payload.doc.data().active;

          if (item.payload.doc.data().deleted) {
            this.arrayProductsHistoric.push(product)
          } else {
            this.arrayProducts.push(product)
          }

          //}

        })

      })
  }

  _getAllOrders () {

    let array: any[] = []
    let tax: number = 0
    let total_minus_tax: number = 0


    this._orderedService.loadAllOrdered()
      .subscribe((result) => {

        //   console.log("all orders: " + JSON.stringify(result))

        result.forEach((item) => {
          let order: any = {}
          order = item.payload.doc.data()
          order.id = item.payload.doc.id
          array.push(order)
        })

        array.sort(this.compareNames)

        array.forEach((item) => {



          /*
          if (item.returnCode == "00") {
 
            console.log("-----------------------------")
            console.log(item.id)
            console.log(item.member_name)
            console.log(item.type)
            console.log(item.payment_type)
 
            if(item.payment_type == 'cartao'){
              this.db.collection('sbccv_orders')
              .doc(item.id)
              .set( {"payment_type": "CreditCard"}, {"merge": true} );
            }
            
          }
          */



        })

      })

  }

  compareNames (a: any, b: any) {

    const pa = String(a.member_name)
    const pb = String(b.member_name)

    if (pa > pb) return 1;
    if (pb > pa) return -1;

    return 0;
  }


  checkCard (item, data) {

    if (item.type === 'CreditCard') {
      const exist = item.brands.find((e) => {
        return e.brand === data.card_brand
      })

      if (exist) {
        exist.count++
      } else {
        item.brands.push({
          'brand': data.card_brand,
          'count': 1
        })
      }

    }

  }


  _loadAllOrders () {

    this._orderedService.loadAllOrdered()
      .subscribe((result) => {

        let array: any[] = []

        let count: number = 0;
        let payment_types: any = []

        result.forEach((item) => {

          if (item.payload.doc.data().returnCode === '00' && item.payload.doc.data().product_id === '2vgQyqXZWjsrYWngGV6A') {

            let order: any = {}
            order = item.payload.doc.data()
            order.id = item.payload.doc.id

            if (order.payment_type === 'CreditCard') {

              const taxBrand = this._orderedService.cielo_values.find((e) => {
                return e.brand === order.card_brand
              })

              const brand = taxBrand.values.find((e) => {
                return e.installments === order.card_installments
              })

              order.tax = brand.tax
            }

            array.push(order)
            count++

          }

        })

        console.log(count)
        console.log('---------------------------------------')
        console.log(JSON.stringify(array))

      })

  }

  loadAllOrders () {

    this._orderedService.loadAllOrdered()
      .subscribe((result) => {

        let array: any[] = []
        let count: number = 0;

        result.forEach((item) => {

          if (item.payload.doc.data().product_id === '2vgQyqXZWjsrYWngGV6A') {

            let order: any = {}
            order = item.payload.doc.data()
            order.id = item.payload.doc.id
            array.push(order)
            count++

          }

        })

        console.log(count)
        console.log('---------------------------------------')
        console.log(JSON.stringify(array))

      })

  }

}


